
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import { BUTTON_SIZE_LABELS, ButtonSize } from "@/types/singularity/brand";

import ButtonGroup from "../../components/ButtonGroup.vue";

@Component({
  components: {
    ButtonGroup
  }
})
export default class BrandToggleFontSizes extends Vue {
  update(buttonSize: ButtonSize) {
    this.$emit("update", buttonSize);
  }

  @Prop()
  value!: ButtonSize[];

  get sizesWithLabels() {
    return this.value.map(size => ({
      label: BUTTON_SIZE_LABELS[size],
      value: size
    }));
  }

  get currentButtonSize() {
    return singularityStore.brand.ui.buttonSize;
  }
}
